"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasValidPlanWith = void 0;
const getSubscriptionState_1 = require("./getSubscriptionState");
const subscriptionState_1 = require("./subscriptionState");
/**
 * Is there a valid subscription (in good standing), with a plan which meets the
 * condition?
 */
function hasValidPlanWith(subscriptions, cond) {
    const entitledSubscriptions = subscriptions.filter((subscription) => (0, getSubscriptionState_1.getSubscriptionState)(subscription).entitlement === subscriptionState_1.Entitlement.Entitled);
    return entitledSubscriptions.some((s) => cond({
        plan: s.plan,
    }));
}
exports.hasValidPlanWith = hasValidPlanWith;
